export default "__VITE_ASSET__KuUK6wfv__"